import { useEffect, useState } from 'react'

type Props = {
    key: string
    defaultValue: unknown
}

const usePersistedState = ({ key, defaultValue }: Props) => {
    const [state, setState] = useState(() => {
        const storedState = localStorage.getItem(key)

        if (!storedState || storedState === '""') {
            return defaultValue
        }

        try {
            return JSON.parse(storedState)
        } catch (e) {
            console.error(`Error parsing stored value for ${key}:`, e)
            return defaultValue
        }
    })

    const handleDeleteState = () => {
        localStorage.removeItem(key)
    }

    useEffect(() => {
        if (state === undefined) {
            localStorage.removeItem(key)
        } else {
            localStorage.setItem(key, JSON.stringify(state))
        }
    }, [key, state])

    return [state, setState, handleDeleteState]
}

export default usePersistedState
